import React, {MutableRefObject, useState} from "react";
import {Col, ConfigProvider, Row} from "antd";

import Visual from "./Visual";
import Editor from "./Editor";

import {EventService} from "../services/eventService";
import {parse, Pattern, Round} from "./Parsing";
import Timer from "./Timer";
import SelectInspector from "./SelectInspector";
import {Annotation} from "react-ace/types";
import {IMarker} from "react-ace";
import BrowserSizeModal from "../shared/BrowserSizeModal";

type Props = {
    userId: string,
    taskId: string,
    children: React.ReactNode,
    initialText: string
    setRowInspectorRef: MutableRefObject<null>
}

export default function IDE(props: Props) {
    const eventService = new EventService();

    const [pattern, setPattern] = useState({rows: [], gauge: []} as Pattern);
    const [errors, setErrors] = useState([] as Annotation[]);
    const [markers, setMarkers] = useState([] as IMarker[]);
    const [cursor, setCursor] = useState("pointer");

    const build = (text: string) => {
        //TODO make sure initial state is set as an event
        const date = new Date();
        eventService.saveEvent(props.userId, props.taskId, {
            id: date.valueOf(),
            type: "TYPING",
            time: date.toString(),
            value: text
        });

        const {pattern, errors} = parse(text);

        setPattern(pattern);
        setErrors(errors);
    }

    const updateSelectInspector = (roundNum: number) => {
        const markers: IMarker[] = [{
            startRow: roundNum,
            startCol: 2,
            endRow: roundNum,
            endCol: 20,
            className: 'error-marker',
            type: 'fullLine' }];

        setMarkers(markers);
    }

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: '#E27D60',
                },
            }}
        >
            <BrowserSizeModal/>
            <Timer taskId={props.taskId} userId={props.userId}/>
            <Row className="outer-container">
                <Col span={12}>
                    <Row>
                        <Col span={24}>
                            {props.children}
                        </Col>
                    </Row>

                    <Col className={cursor === "crosshair" ? "highlight-border" : ""} style={{ cursor }}>
                        <Row>
                            <Col span={18}><h2 style={{display: "inline"}}>Pattern Visual</h2><p style={{display: "inline", margin: "0px 0px 0px 8px"}}>(Right-Side of Work)</p></Col>
                            <Col span={6}>
                                <SelectInspector
                                    userId={props.userId}
                                    taskId={props.taskId}
                                    onCursorChange={(cursor) => {setCursor(cursor)}}
                                    setRef={props.setRowInspectorRef}
                                />
                            </Col>
                        </Row>
                        <Visual
                            userId={props.userId}
                            taskId={props.taskId}
                            rounds={pattern.rows}
                            gauge={pattern.gauge}
                            hoverActive={cursor === "crosshair"}
                            onHover={(round) => updateSelectInspector(round)}
                        ></Visual>
                    </Col>
                </Col>
                <Col span={12} style={{"padding": "0px 0px 0px 16px"}}>
                    <h2>Pattern Editor</h2>
                    <Editor
                        userId={props.userId}
                        taskId={props.taskId}
                        onChange={(content) => build(content)}
                        errors={errors}
                        markers={markers}
                        initialText={props.initialText}
                    />
                </Col>
            </Row>
        </ConfigProvider>
);
}